import { useState } from 'react';
import { OrgTree } from './OrgTree';
import { UsersManagement } from './UsersManagement';
import { InvitationsPanel } from './InvitationsPanel';
import { FeatureFlagsPanel } from './FeatureFlagsPanel';
import { TenantsPanel } from './TenantsPanel';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores/authStore';
import { InfoTip } from '../shared/InfoTip';
import styles from './AdminPage.module.css';

type Tab = 'organizations' | 'users' | 'invitations' | 'feature-flags' | 'tenants';

export function AdminPage() {
  const { t } = useTranslation('admin');
  const [activeTab, setActiveTab] = useState<Tab>('organizations');
  const user = useAuthStore((s) => s.user);
  const isSuperAdmin = user?.role === 'super_admin';

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h2>{t('title')}<InfoTip text={t('tooltips.admin')} /></h2>
      </div>

      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === 'organizations' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('organizations')}
        >
          {t('organizations')}
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'users' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('users')}
        >
          {t('users')}
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'invitations' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('invitations')}
        >
          {t('invitations')}
        </button>
        {isSuperAdmin && (
          <>
            <button
              className={`${styles.tab} ${activeTab === 'feature-flags' ? styles.activeTab : ''}`}
              onClick={() => setActiveTab('feature-flags')}
            >
              {t('featureFlags')}
            </button>
            <button
              className={`${styles.tab} ${activeTab === 'tenants' ? styles.activeTab : ''}`}
              onClick={() => setActiveTab('tenants')}
            >
              {t('tenants')}
            </button>
          </>
        )}
      </div>

      {activeTab === 'organizations' && <OrgTree />}
      {activeTab === 'users' && <UsersManagement />}
      {activeTab === 'invitations' && <InvitationsPanel />}
      {activeTab === 'feature-flags' && isSuperAdmin && <FeatureFlagsPanel />}
      {activeTab === 'tenants' && isSuperAdmin && <TenantsPanel />}
    </div>
  );
}
